<template>
  <div class="box-outer" :class="{'-half': isHalfWidth}">
    <div class="box-inner">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isHalfWidth: {
      type: Boolean,
      default: false,
    }
  }
}
</script>>
<style lang="scss" scoped>
.box-outer {
  width: 608px;
  margin: 0 auto;
  padding: 45px 0 70px;
  background-image: 
    url(#{$img-path}window-box-blue/bg_window-top.png),
    url(#{$img-path}window-box-blue/bg_window-bottom.png);
  background-position: 50% 0, 50% 100%;
  background-repeat: no-repeat, no-repeat;
  background-size: 100% auto, 100% auto;
  &.-half {
    width: 340px;
    padding: 50px 0;
    background-image: 
      url(#{$img-path}window-box-blue/bg_window-top-half.png),
      url(#{$img-path}window-box-blue/bg_window-bottom-half.png);
    .box-inner {
      background-image: url(#{$img-path}window-box-blue/bg_window-middle-half.png);
    }
  }
  /deep/ a {
    color: #91f8ff;
    text-decoration: underline;
  }
}
.box-inner {
  white-space: pre-wrap;
  height: 100%;
  background-image: url(#{$img-path}window-box-blue/bg_window-middle.png);
  background-repeat: repeat-y;
  background-position: 50% 0;
  background-size: 100% auto;
  color: #fff;
  text-shadow: $ts-base;
  padding: 0 50px;
}
.-half .box-inner {
  padding: 0;
}
</style>